export const GOOGLE_AUTH_ERRORS = {
  POPUP_CLOSED_BY_USER: 'popup_closed_by_user',
  ACCESS_DENIED: 'access_denied',
  IMMEDIATE_FAILED: 'immediate_failed',
}
